import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

const mutateAddBudget = async ({
  communityId,
  data,
}: {
  communityId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.post(BUDGET(communityId), data);
};

const useAddBudgetMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddBudget,
    ...queryParams,
  });

export default useAddBudgetMutation;
